<style scoped lang="less">
.settings-container{
  padding: 16px 20px;
  background: #f4f7fc;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  flex-direction: column;
  z-index: -1;

  .method_head {
    font-size: 14px;
  }
  .method_wrapper {
    width: auto;
    flex: 1;
    background: #ffffff;
    box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    margin-top: 16px;

    .method_search_wrapper {
      display: flex;
      padding: 30px;
      width: auto;
      border-bottom: 1px solid rgba(207, 212, 232, 0.5);
      font-size: 16px;

      .method_search {
        display: flex;
        /*width: 16.25rem;*/
        width: 100%;
        .tabs-nav{
          cursor: pointer;
          font-size: 1.2rem;
          margin-right: 30px;
          padding-bottom: 5px;
        }
        .active{
          color: rgb(0, 88, 255);
          border-bottom: 2px solid rgb(0, 88, 255);
        }
      }

    }

  }

}
</style>

<template>
  <div class="settings-container">
    <div class="method_head">
      <span style="color: #b2b2b2">系统设置 /</span>
      <span style="color: #5c5c5c"> 系统配置</span>
    </div>

    <div class="method_wrapper">
      <div class="method_search_wrapper">
        <div class="method_search">
          <div v-if="isAdmin" :class="activeName == 'system'?'tabs-nav active': 'tabs-nav'" @click="activeName='system'">系统参数</div>
          <div v-if="isAdmin" :class="activeName == 'attendanceNotification'?'tabs-nav active': 'tabs-nav'" @click="activeName='attendanceNotification'">考勤通知</div>
          <div :class="activeName == 'updatepass'?'tabs-nav active': 'tabs-nav'" @click="activeName='updatepass'">修改密码</div>
        </div>
      </div>
      <div style="padding: 30px;">
        <system-parameter v-if="activeName == 'system' && isAdmin"></system-parameter>
        <updatepass v-if="activeName == 'updatepass'"></updatepass>
        <attendance-notification v-if="activeName == 'attendanceNotification' && isAdmin"></attendance-notification>
      </div>
    </div>
  </div>
</template>



<script>
import SystemParameter from "@/views/account/setting/systemParameter.vue";
import Updatepass from "@/views/account/setting/updatepass.vue";
import AttendanceNotification from "@/views/account/setting/attendanceNotification.vue";
import {CompanyApi} from "@/api/server/company";
export default {
  components: {
    SystemParameter,Updatepass, AttendanceNotification
  },
  data() {
    return {
      activeName: 'system',
      isAdmin: false
    };
  },
  created() {
    this.init();
  },
  mounted() {

  },
  methods: {
    async init() {
      let that = this;
      const response = await CompanyApi.queryCurrentCompany();
      let {code, data} = response;
      if (code == 200) {
        that.systemVersionType = data?.systemVersionType || 1;
      }
      let item = localStorage.getItem("userinfo");
      if(item){
          let userInfo = JSON.parse(item);
          this.isAdmin = userInfo?.status == 4;
          if(!this.isAdmin){
            this.activeName = 'updatepass';
          }
      }
    },
  }
};
</script>